import { DialogPopup, DialogPopupTypes } from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'

const DialogPopupHandlerComponent = () => {
  const {
    generalStore: { dialogPopupProps, closeDialogPopup }
  } = useRootStore()

  if (!dialogPopupProps) return null

  return (
    <DialogPopup
      colorPreset='dark'
      type={DialogPopupTypes.INFO}
      {...dialogPopupProps}
      onClose={() => {
        dialogPopupProps.onClose && dialogPopupProps.onClose()
        closeDialogPopup()
      }}
    />
  )
}

const DialogPopupHandler = observer(DialogPopupHandlerComponent)
export { DialogPopupHandler }
